/**
 * Chess Board Component (CSS Theme)
 * Uses CSS classes from chess-components.css for all styling
 */
import type { BoardProps } from "../../types";
import { SquareThemed } from "../square";
import { BoardBase } from "./BoardBase";

export function BoardThemed(props: BoardProps) {
  return (
    <BoardBase
      {...props}
      renderSquare={({
        file,
        rank,
        piece,
        isSelected,
        isLegalMove,
        isCapture,
        isAugmented,
        onClick,
      }) => (
        <SquareThemed
          key={`${file}${rank}`}
          file={file}
          rank={rank}
          piece={piece}
          isSelected={isSelected}
          isLegalMove={isLegalMove}
          isCapture={isCapture}
          isAugmented={isAugmented}
          onClick={onClick}
          isMyTurn={props.isMyTurn}
          gameEnded={props.gameEnded}
        />
      )}
      className="chess-board"
    />
  );
}
